import React from 'react';

interface EntitySelectorProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

const ENTITIES = [
  { id: 'clients', label: 'Clientes', icon: '👤', description: 'Importar clientes desde Excel' },
  { id: 'projects', label: 'Proyectos', icon: '📋', description: 'Importar proyectos desde Excel' },
  { id: 'payments', label: 'Pagos', icon: '💰', description: 'Importar pagos desde Excel' },
  { id: 'expenses', label: 'Gastos', icon: '💳', description: 'Importar gastos desde Excel' }
];

export function EntitySelector({ value, onChange, disabled = false }: EntitySelectorProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      {ENTITIES.map((entity) => (
        <button
          key={entity.id}
          type="button"
          onClick={() => onChange(entity.id)}
          disabled={disabled}
          className={`p-4 border-2 rounded-lg text-left transition-all ${
            value === entity.id
              ? 'border-primary bg-primary-light'
              : 'border-gray-200 hover:border-gray-300'
          } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
          <div className="flex items-center gap-3">
            <span className="text-2xl">{entity.icon}</span>
            <div>
              <div className="font-medium">{entity.label}</div>
              <div className="text-xs text-gray-500">{entity.description}</div>
            </div>
            {value === entity.id && (
              <span className="ml-auto text-primary">✓</span>
            )}
          </div>
        </button>
      ))}
    </div>
  );
}